/** 设置加载中 */
export function Loading<T>(loadings: (keyof T)[]): MethodDecorator {
  return function (t, p: PropertyKey, d: PropertyDescriptor) {
    const fn = d.value;
    d.value = async function (this: T, ...args) {
      let res;
      try {
        loadings.forEach((k) => (this[k] = true as unknown as T[keyof T]));
        res = await Reflect.apply(fn, this, args);
      } finally {
        loadings.forEach((k) => (this[k] = false as unknown as T[keyof T]));
      }
      return res;
    };
  };
}
